import { render, staticRenderFns } from "./SavedSearchRenameDialog.vue?vue&type=template&id=5f330294&scoped=true"
import script from "./SavedSearchRenameDialog.vue?vue&type=script&lang=js"
export * from "./SavedSearchRenameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f330294",
  null
  
)

export default component.exports